export default __webpack_public_path__ + "static/media/banksafe_logo.380d998b.svg";